<template>

  <div id="login" class="centered-container">
    <md-content class="md-elevation-3">
      <div class="title">
        <img :src="imgUrl()">
      </div>

      <div class="form" v-if="steps[currentStep] === 'email'">
        <div class="instructions">
          Para recuperar su contraseña escriba el correo electronico con el que se registro.
          Si coincide se le enviara un codigo para verificar su cuenta
        </div>

        <md-field>
          <md-input v-model="email" :placeholder="emailHint" autofocus></md-input>
        </md-field>

        <div class="actions md-layout md-alignment-center">
          <md-button class="md-raised md-primary" @click="requestCode" data-toggle="modal"
            data-target="#loading-modal-modal">Solicitar Codigo</md-button>
        </div>
      </div>

      <div class="form" v-if="steps[currentStep] === 'code'">
        <p class="instructions">
          Ingrese el código de verificación
        </p>

        <code-input @input="onCodeInput"></code-input>

        <div class="actions md-layout md-alignment-center">
          <md-button class="md-raised md-primary" @click="verifyCode" data-toggle="modal"
            data-target="#loading-modal-modal">Validar</md-button>
        </div>
      </div>

      <div class="form" v-if="steps[currentStep] === 'password'">

        <md-field>
          <label>Ingrese su nueva contraseña</label>
          <md-input type="password" v-model="password"></md-input>
        </md-field>
        <md-field>
          <label>Confirme su nueva contraseña</label>
          <md-input type="password" v-model="confirmPassword"></md-input>
        </md-field>

        <div class="actions md-layout md-alignment-center">
          <md-button class="md-raised md-primary" @click="resetPassword" data-toggle="modal"
            data-target="#loading-modal-modal">Actualizar</md-button>
        </div>
      </div>

      <div class="recovery-done" v-if="steps[currentStep] === 'start'">
        <md-button class="md-raised md-primary" @click="gotoLogin">Inicio de sesión</md-button>
      </div>

      <div class="recovery-done" v-if="steps[currentStep] === 'error'">
        <md-button class="md-raised md-primary" @click="gotoLogin">Regresar al inicio</md-button>
      </div>
    </md-content>

    <modal :name="modalName" cclass="transparent">
      <loading-modal :info="modalInfo"></loading-modal>
    </modal>

  </div>
</template>

<script>
import CodeInput from './CodeInput.vue';
let Modal = () => import('reusable/Modal')
let LoadingModal = () => import('components/Modals/LoginModal')
import { mapState } from 'vuex';

export default {
  data() {
    return {
      recovery: this.$store.state.recovery,
      steps: ['email', 'code', 'password', 'start', 'error'],
      currentStep: 0,
      password: '',
      confirmPassword: '',
      email: '',
      emailHint: '',
      modalName: 'loading-modal',
      verificationCode: '',
      guid: '',
    }
  },
  computed: mapState(['user', 'modalInfo']),
  methods: {
    imgUrl() {
      return require('imgs/logos/Logo_' + process.env.SITE_TYPE + '.png');
    },
    onCodeInput(code) {
      this.verificationCode = code;
    },
    requestCode() {
      this.$store.dispatch('requestCode', { email: this.email, guid: this.guid })
        .then(resp => {
          console.log('request code', resp);
          if (resp) {
            this.currentStep = 1;
          }
          this.closeModal();
        })
        .catch(err => {
          this.closeModal();
          console.log(err)
        })
    },
    verifyCode() {
      this.$store.dispatch('verifyCode', { code: this.verificationCode, guid: this.guid })
        .then(resp => {
          console.log('verify code', resp);
          if(resp) {
            this.currentStep = 2;
          }
          this.closeModal();
        })
        .catch(err => {
          console.log(err)
          this.closeModal();
        })
    },
    resetPassword() {
      this.$store.dispatch('resetPassword', {
        password: this.password,
        confirmPassword: this.confirmPassword,
        guid: this.recovery.recoveryGuid,
        code: this.verificationCode
      })
        .then(resp => {
          this.closeModal();
          this.currentStep = 3;
        })
        .catch(err => {
          this.closeModal();
        })
    },
    gotoLogin() {
      this.$router.replace('/login')
    },
    closeModal() {
      $(this.$router.app.$children[0])[0].closeModal();
    }
  },
  components: {
    CodeInput,
    Modal,
    LoadingModal
  },
  created() {
    const recovery = this.recovery;
    this.guid = recovery.recoveryGuid;

    if(!this.recovery) {
      return this.$router.replace('')
    }
    
    this.emailHint = recovery ? recovery.email : 'Correo';
    if (!recovery) {
      return this.$router.replace('/dashboard')
    }
  },
  mounted() {
    this.$store.commit('setModalInfo', { modalName: this.modalName });
    document.querySelector('body').addEventListener('keydown', (e) => {
      if (e.code === 'Enter') {
        const loginBtn = document.querySelector('#login-btn');
        if (loginBtn) loginBtn.click()
      }
    })
  },
}
</script>

<style lang="scss" scoped>
@import '~varmix';

.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;

  .title {
    text-align: center;
    margin-bottom: 30px;

    img {
      width: 100%;
    }
  }

  .instructions {
    text-align: center;
    font-size: 16px;
    margin: 20px 0;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }


  .actions {
    .md-button {
      margin: 0;
    }
  }

  .form {
    margin-bottom: 60px;
  }

  .recovery-done {
    text-align: center;
    margin-bottom: 20px;
    margin-top: 40px;
  }
  .background {

    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;

    background-color: var(--loading-background-color);
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;

  }

  .md-content {
    z-index: 1;
    padding: 40px;
    width: 100%;
    max-width: 400px;
    position: relative;
    border-radius: 15px;
  }

}

#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// PasswordRecovery.vue?c41647fe